/**
 * Embed the 100ms Prebuilt room in an iframe.
 *
 * The iframe approach is dependency-free (no SDK conflict with React 19),
 * still gives us the full feature set (video/audio/chat/screen-share/recording),
 * and can be visually customized via the 100ms dashboard
 * (Templates → Customize Appearance).
 *
 * Permissions delegated to the iframe:
 *   - camera, microphone, display-capture (screen share)
 *   - autoplay (so the lobby video preview starts)
 *   - fullscreen
 */
const VideoInterviewRoom = ({ joinUrl }) => {
  if (!joinUrl) {
    return (
      <div className="flex-1 flex items-center justify-center bg-slate-950 text-slate-300 text-sm">
        Carregando sala…
      </div>
    );
  }
  return (
    <iframe
      data-testid="video-iframe"
      title="GridRecruiter — Entrevista por vídeo"
      src={joinUrl}
      allow="camera; microphone; display-capture; autoplay; fullscreen; clipboard-write"
      allowFullScreen
      className="flex-1 w-full h-full border-0 bg-slate-950"
    />
  );
};

export default VideoInterviewRoom;
